import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerStatusLookup } from '../../api/models';

export type TABLE_TYPE = Table<PlayerStatusLookup>;

export const TABLE = 'playerStatusLookups';
const SCHEMA = 'playerStatusLookupId, sortId';

class PlayerStatusLookupsDatabase implements DataRepository<PlayerStatusLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerStatusLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerStatusLookup, key: Key): Promise<PlayerStatusLookup> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PlayerStatusLookup[]): Promise<PlayerStatusLookup[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PlayerStatusLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PlayerStatusLookupsDB = new PlayerStatusLookupsDatabase(db);
